import getTableConversationRelation from '../utils/getTableConversationRelation';
import type TableView from '../store/schema/TableView';
import { getIsPinnedTimestamp } from '../utils/pinningUtils';
import { getItemFromNodeId } from 'owa-mail-store/lib/utils/conversationsUtils';
import { getListViewStore } from '../store/Store';
import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { type MailListDataPropertyEnum } from './MailListDataPropertyEnum';
import { type TableQueryType } from '../store/schema/TableQuery';
import type Item from 'owa-service/lib/contract/Item';

export default (
    conversationId: string,
    tableView: TableView,
    propertyType: MailListDataPropertyEnum
) => {
    const tableConversationRelation = getTableConversationRelation(conversationId, tableView?.id);
    const conversationItem = getListViewStore().conversationItems.get(conversationId);

    if (!tableConversationRelation || !conversationItem) {
        return null;
    }

    switch (propertyType) {
        case 0:
            return tableConversationRelation.lastDeliveryTimeStamp;

        case 1:
            return tableConversationRelation.lastDeliveryOrRenewTimeStamp;

        case 2:
            return tableConversationRelation.lastModifiedTimeStamp;

        case 3:
            return conversationItem.subject || getOwaMiniStrings().noSubject;

        case 4:
            if (tableView.tableQuery.type === 1) {
                return tableConversationRelation.parentFolderId;
            }
            // Use tableView.tableQuery.folderId for non-search scenarios,
            // because parentFolderId is not returned for findConversation
            return tableView.tableQuery.folderId;

        case 5:
            return tableConversationRelation.uniqueRecipients;

        case 6:
            return tableConversationRelation.uniqueSenders;

        case 7:
            return tableConversationRelation.lastSender;

        case 8:
            return tableConversationRelation.unreadCount;

        case 9:
            return tableConversationRelation.previewText;

        case 10:
            return getIsPinnedTimestamp(tableConversationRelation.lastDeliveryOrRenewTimeStamp);

        case 11:
            return tableConversationRelation.flagStatus;

        case 12:
            return tableConversationRelation.shouldShowRSVP;

        case 13:
            return tableConversationRelation.rsvpUnitAriaDetails;

        case 14:
            return tableConversationRelation.itemIds;

        case 15:
            return tableConversationRelation.id;

        case 16:
            const conversationItemParts = getMailStore().conversations.get(conversationId);
            let firstItem: Item = null;
            if (conversationItemParts?.conversationNodeIds.length > 0) {
                firstItem = getItemFromNodeId(conversationItemParts.conversationNodeIds[0]);
            }
            return firstItem?.InferenceClassification;

        default:
            return null;
    }
};
